// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col {
  width: 20%;
}

@media screen and (max-width: 450px) {
  .col:last-of-type {
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/transaction-list/transaction-list.component.scss"],"names":[],"mappings":"AACA;EACI,UAAA;AAAJ;;AAGA;EACI;IACI,WAAA;EAAN;AACF","sourcesContent":["\r\n.col {\r\n    width:20%;\r\n}\r\n\r\n@media screen and (max-width: 450px) {\r\n    .col:last-of-type {\r\n        width: auto;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
